import React from "react";
import { Badge } from "reactstrap";
import ModalInterface from "../ModalInterface";
import "../../assets/css/changeStations.css";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import { STATION_CLOSE_MODAL } from "../../store/types";

import { useNavigate } from "react-router-dom";

const StationRecallModal = ({
  showSectionRecallModal,
  setShowSectionRecallModal,
}) => {
  let navigate = useNavigate();

  const userStations = useSelector(
    (state) => state?.authUser?.user?.data?.stations
  );

  const cardStation = useSelector((state) => state?.info?.id?.stationName);

  const dispatch = useDispatch();
  const [stNameToBe, setStNameToBe] = useState(cardStation?.station);

  useEffect(() => {
    setStNameToBe(cardStation?.station);
  }, [cardStation]);

  return (
    <ModalInterface
      display={showSectionRecallModal}
      //   setDisplay={setDisplay}
      closeEvent={() => {
        dispatch({ type: STATION_CLOSE_MODAL });
        setStNameToBe(cardStation?.station);
      }}
      className={"text-center"}
      size={"md"}
      content={
        <>
          <div className="stations-input ">
            {userStations?.map((item) => {
              return (
                <>
                  {item === "all" ? (
                    ""
                  ) : item === stNameToBe ? (
                    <Badge href="#" color="" pill className="muted p-2 mx-2">
                      <span className="text-muted">{item}</span>
                    </Badge>
                  ) : (
                    <Badge
                      href="#"
                      color="info"
                      className="p-2 m-2"
                      pill
                      onClick={() => {
                        setStNameToBe(item);

                        navigate("/admin/dashboard/single-order", {
                          state: { order: "cooked", station: item },
                        });

                        setShowSectionRecallModal(false);
                      }}
                    >
                      <span>{item}</span>
                    </Badge>
                  )}
                </>
              );
            })}
          </div>
        </>
      }
      title={<span>Scegli la stazione da visualizzare</span>}
    />
  );
};

export default StationRecallModal;
